import React, { FC } from "react";
import { ThemeBuilderSectionLine } from "../WidgetThemeBuilder/ThemeBuilderSectionLine";
import { WidgetValuePicker, WidgetValuePickerChildrenProps } from "../WidgetThemeBuilder/WidgetValuePicker";
import { Select } from "@xapp/components";
import { SearchWidgetBorderStyleTheme } from "./SearchWidgetTypes";
import style from "../WidgetThemeBuilder/style.scss";

export interface SearchWidgetBorderStylePickerProps {
    readonly label?: string;
    readonly value: string | undefined;
    readonly defaultValue: string | undefined;
    onChange(value: SearchWidgetBorderStyleTheme): void;
}

const styles: readonly SearchWidgetBorderStyleTheme[] = ["solid", "dashed", "none"];
const items = styles.map((style) => ({ label: style, value: style }));

export const SearchWidgetBorderStylePickerRaw: FC<WidgetValuePickerChildrenProps<string>> = ({
    onChange,
    override,
    value
}: WidgetValuePickerChildrenProps<string>) => {

    function handleChange(value: string) {
        onChange(value);
    }

    return (
        <Select
            items={items}
            className={style.fontFamilyValue}
            disabled={override} value={value}
            onChange={handleChange}
        />
    );
};

export const SearchWidgetBorderStylePicker: FC<SearchWidgetBorderStylePickerProps> = ({
    label,
    value,
    defaultValue,
    onChange
}: SearchWidgetBorderStylePickerProps) => {
    return (
        <ThemeBuilderSectionLine label={label ?? "Border style"}>
            <WidgetValuePicker<string> value={value} defaultValue={defaultValue} children={SearchWidgetBorderStylePickerRaw} onChange={onChange} />
        </ThemeBuilderSectionLine>
    );
};